import { render, staticRenderFns } from "./JobDashboard.vue?vue&type=template&id=6db91521&scoped=true&"
import script from "./JobDashboard.vue?vue&type=script&lang=ts&"
export * from "./JobDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./JobDashboard.vue?vue&type=style&index=0&id=6db91521&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db91521",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VIcon,VSheet,VSpacer})
